export const getFullName = ({
  firstName,
  lastName
}) => {
  return firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName;
};